import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { MerchantsTable } from "@/components/merchants/merchants-table";
import { Button } from "@/components/ui/button";
import { IconPlus, IconDownload } from "@tabler/icons-react";
import { DataExportDialog } from "@/components/shared/data-export-dialog";
import { useExportMerchants } from "@/hooks/use-data-export";
import { useState } from "react";

export const Route = createFileRoute("/merchants/")({
  component: MerchantsPage,
});

function MerchantsPage() {
  return (
    <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
      <AppShell>
        <MerchantsContent />
      </AppShell>
    </ProtectedRoute>
  );
}

function MerchantsContent() {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const exportMerchants = useExportMerchants();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Merchants</h1>
          <p className="text-muted-foreground">
            Manage merchant accounts and configurations
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setExportDialogOpen(true)}
          >
            <IconDownload className="mr-2 h-4 w-4" />
            Export
          </Button>
          <Link to="/merchants/create">
            <Button size="sm">
              <IconPlus className="mr-2 h-4 w-4" />
              Add Merchant
            </Button>
          </Link>
        </div>
      </div>

      <MerchantsTable />

      <DataExportDialog
        open={exportDialogOpen}
        onOpenChange={setExportDialogOpen}
        title="Export Merchants"
        description="Export merchant data including balances, commissions, and statistics"
        onExport={async (params) => exportMerchants.mutateAsync(params) as unknown as Promise<Blob>}
        filename="merchants"
      />
    </div>
  );
}
